export default {
  props: {
    mode: String,
    origin: String,
    transition: String
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/vuetify/es5/mixins/transitionable.js
// module id = null
// module chunks = 